<template>
  <div class="zhubo-player">
    <div class="zhubo-cover" v-if="userInfo && userInfo.backgroundUrl">
      <div class="zhubo-cover-box">
        <img class="zhubo-cover-img" :src="userInfo.backgroundUrl" alt="" />
      </div>
    </div>
    <video
      class="zhubo-video"
      :id="playerId"
      preload="auto"
      playsinline
      webkit-playsinline
      style="object-fit: cover;"
    ></video>
	<div class="xtzb-item-user">
	  <span class="xtzb-item-user-sort">1</span>
	  <span class="xtzb-item-user-name">主播</span>
	</div>
  </div>
</template>

<script>
export default {
  name: "zhuboplayer",
  props: {
    pullUrl: {
      type: String,
      default: ''
    },
    userInfo: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      player: null,
      playerId: null,
      licenseUrl: "https://1383640469.sdk-license.com/license/v2/1383640469_1/v_cube.license"
    };
  },
  mounted() {
    this.playerId = 'zhubo-player-' + Date.now();
    this.$nextTick(() => {
      this.initPlayer();
    });
	console.log(this.userInfo)
  },
  watch: {
    pullUrl: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.$nextTick(() => {
            this.initPlayer();
          });
        }
      }
    },
    userInfo: {
      immediate: true,
      handler(newVal) {
        console.log('zhuboplayer userInfo updated:', newVal);
      }
    }
  },
  beforeDestroy() {
    if (this.player) {
      try {
        this.player.pause();
      } catch (e) {
        console.warn('播放器暂停异常:', e);
      }
      try {
        this.player.src('');
      } catch (e) {
        console.warn('播放器设置src异常:', e);
      }
      try {
        const container = document.getElementById(this.playerId);
        if (container) {
          this.player.dispose();
        }
      } catch (e) {
        console.warn('播放器清理异常:', e);
      }
      this.player = null;
    }
  },
  methods: {
    initPlayer() {
      if (!this.pullUrl) return;
      
      if (!this.player) {
        this.player = TCPlayer(this.playerId, {
          sources: [{
            src: this.pullUrl
          }],
          licenseUrl: this.licenseUrl,
          autoplay: true,
          controls: false,
          webrtcConfig: {
            connectRetryCount: 999999
          }
        });
      } else {
        this.player.src(this.pullUrl);
        this.player.play();
      }
    }
  }
};
</script>

<style scoped lang="scss">
.zhubo-player {
  width: 100%;
  height: 100px;
  position: relative;
  background: #000;
}

.zhubo-cover {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
}

.zhubo-cover-box {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.zhubo-cover-img {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 5px;
}

.zhubo-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
}
.xtzb-item-user{
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px;
  z-index: 10;
}
.xtzb-item-user-sort{
	width: 14px;
	height: 14px;
	background: rgba(0,0,0,0.4);
	border-radius: 16px 16px 16px 16px;
	font-family: MiSans, MiSans;
	font-weight: 400;
	font-size: 9px;
	color: #FFFFFF;
	line-height: 14px;
	text-align: center;
}
.xtzb-item-user-name{
	font-family: MiSans, MiSans;
	font-weight: 400;
	font-size: 12px;
	color: #FFFFFF;
	margin-left: 4px;
}
</style>
<style>
.zhubo-video video {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  object-fit: cover !important;
}

.zhubo-video video::-webkit-media-controls {
  display: none !important;
}

.zhubo-video video::-webkit-media-controls-enclosure {
  display: none !important;
}

.zhubo-video video::-webkit-media-controls-panel {
  display: none !important;
}
</style>


// WEBPACK FOOTER //
// zhuboplayer.vue?70594668